import React, { useState } from 'react';
import { Button, Grid2 } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useFormContext } from 'react-hook-form';
import { COLORS } from '../../../utils/Application_Constants';
import CancelDialog from '../Dialog/CancelDialog';

const styles = () => ({
    cancelButton: {
        backgroundColor: COLORS.LT_PEPPER10,
        color: COLORS.LT_PEPPER,
        '&:hover': {
            backgroundColor: COLORS.LT_PEPPER25,
        },
    },
    submitButton: {
        backgroundColor: COLORS.LT_EMERALD,
        '&:hover': {
            backgroundColor: COLORS.LT_EMERALD75,
        },
        color: 'white',
    },
    primaryLite: {
        backgroundColor: COLORS.LT_JOURNEY10,
        '&:hover': {
            backgroundColor: COLORS.LT_JOURNEY25,
        },
        color: COLORS.LT_JOURNEY,
    },
});

const ExpenseButtons = (props) => {
    const {
        classes,
        validateSubmit,
        validateSave,
        expensesPath,
        alwaysShowSave = false,
        isViewOnly = false,
        enableEditByModal = false,
    } = props;
    const {
        formState: { isDirty },
    } = useFormContext();
    const history = useHistory();
    const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const { id } = useParams();

    const handleCancel = () => {
        if (isDirty) {
            return setCancelDialogOpen(true);
        }
        history.push(expensesPath);
    };

    return (
        <Grid2 container spacing={3}>
            {!id && (
                <Grid2 item>
                    <Button
                        variant="contained"
                        className={classes.submitButton}
                        color="primary"
                        onClick={validateSubmit}
                    >
                        Submit Expense
                    </Button>
                </Grid2>
            )}
            {(((id || alwaysShowSave) && !isViewOnly) || enableEditByModal) && (
                <Grid2 item>
                    <Button
                        variant="contained"
                        className={classes.primaryLite}
                        color="primary"
                        onClick={validateSave}
                    >
                        Save
                    </Button>
                </Grid2>
            )}
            {/* Segment above is showing id number? */}
            {(!isViewOnly || enableEditByModal) && (
                <Grid2 item>
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        className={classes.cancelButton}
                        color="primary"
                    >
                        Cancel
                    </Button>
                </Grid2>
            )}
            <CancelDialog
                open={cancelDialogOpen}
                setOpen={setCancelDialogOpen}
                nextPath={expensesPath}
            />
        </Grid2>
    );
};

export default withStyles(styles)(ExpenseButtons);
